(() => {
  const trigger = document.querySelector('.support-chat');
  const panel = document.getElementById('support-panel');
  if (!trigger || !panel) return;

  const close = panel.querySelector('.support-close');

  function setOpen(open) {
    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
    if (open) {
      (close || panel).focus();
    } else {
      trigger.focus();
    }
  }

  trigger.addEventListener('click', () => setOpen(panel.hidden));
  if (close) close.addEventListener('click', () => setOpen(false));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !panel.hidden) setOpen(false);
  });

  // Expose for chat opener so live chat can dismiss the panel first
  window.tedSupportPanel = { setOpen, panel, trigger };
})();
